import React, { useState, useContext } from 'react';
import { login, getUser } from '../api';
import { UserContext } from '../UserContext';
import { Link, useNavigate } from 'react-router-dom';
import { Box, Typography, TextField, Button } from '@mui/material';

const LoginPage = () => {
  const [credentials, setCredentials] = useState({ email: '', password: '' });
  const [error, setError] = useState(null);
  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { token } = await login(credentials);
      localStorage.setItem('token', token); // Store the token
      const user = await getUser();
      setUser(user);
      navigate('/'); // Redirect to the home page
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 3,
        maxWidth: 400,
        margin: '0 auto',
        boxShadow: 3,
        borderRadius: 2,
        bgcolor: 'background.paper',
      }}
    >
      <Typography variant="h4" gutterBottom>
        Connexion
      </Typography>
      
      {error && (
        <Typography variant="body2" sx={{ color: 'error.main', marginBottom: 2 }}>
          {error}
        </Typography>
      )}
      
      <form onSubmit={handleSubmit} style={{ width: '100%' }}>
        <TextField
          label="Email"
          name="email"
          type="email"
          onChange={handleChange}
          required
          fullWidth
          margin="normal"
          variant="outlined"
        />
        <TextField
          label="Mot de passe"
          name="password"
          type="password"
          onChange={handleChange}
          required
          fullWidth
          margin="normal"
          variant="outlined"
        />
        
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2 }}
        >
          Se connecter
        </Button>
      </form>

      <Typography variant="body2" sx={{ mt: 2 }}>
        Pas encore de compte ?{' '}
        <Link to="/signup" style={{ textDecoration: 'none' }}>
          Inscrivez-vous ici
        </Link>.
      </Typography>
    </Box>
  );
};

export default LoginPage;